import {
  ORGSI_FREE_DATA,
  ORGSI_GR_REQUEST,
  ORGSI_LIST_REQUEST,
  ORGSI_SI_ADD,
  ORGSI_FILE_ADD,
  ORGSI_FILE_DELETE,
  ORGSI_SI_UPDATE,
  ORGSI_SI_DELETE,
  ORGSI_SET_SILIST_LOADING_STATE,
  ORGSI_SI_SET

} from '../actions/orgsi'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
import axios from 'axios'
const state = {
  currentSI: {},
  SIList: [],
  SIListFilter: null,
  SIListLoading: false
}

const getters = {
  getCurrentSIID: state => state.currentSI.SI_ID,
  getCurrentSI: state => state.currentSI,
  getCurrentSIList: state => state.SIList,
  getSIListLoading: state => state.SIListLoading,
  getCurrentSIListFilter: state => {
    var silf = state.SIListFilter
    return silf
  },
  getCurrentSIFiles: state => {
    return state.currentSI.FILE_LIST || []
  }

}

const actions = {
  [ORGSI_FREE_DATA]: ({ commit }) =>
    new Promise((resolve) => {
      commit(ORGSI_FREE_DATA)
      resolve('success')
    }),
  [ORGSI_SI_SET]: ({ commit }, params) =>
    new Promise((resolve) => {
      commit(ORGSI_SI_SET, params)
      resolve(params)
    }),
  [ORGSI_LIST_REQUEST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_LIST_REQUEST', topic: 'Загрузка списка СИ организации', error: null })
      commit(ORGSI_SET_SILIST_LOADING_STATE, true)
      axios({ url: '/api/org/si/getsilist.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORGSI_LIST_REQUEST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'ORGSI_LIST_REQUEST' })
            resolve(resp.data.data)
          } else {
            console.log('Claim Organisation SI list request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'ORGSI_LIST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_LIST_REQUEST', result: 'Получение списка СИ организации: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(ORGSI_SET_SILIST_LOADING_STATE, false)
        })
    }),
  [ORGSI_GR_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_GR_REQUEST', topic: 'Загрузка списка СИ из справочника Госреестра', error: null })
      commit(ORGSI_SET_SILIST_LOADING_STATE, true)
      axios({ url: '/api/org/si/searchGR.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORGSI_GR_REQUEST)
            dispatch(UI_SUCCESS, { action: 'ORGSI_GR_REQUEST' })
            resolve(resp.data.data)
          } else {
            console.log('Search GR Data request error: ', resp.data.error_text)
            dispatch(UI_ERROR, { action: 'ORGSI_GR_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_GR_REQUEST', result: 'Загрузка списка СИ из справочника Госреестра: ошибка сервера' })
          reject(new Error(err))
        })
        .finally(() => {
          commit(ORGSI_SET_SILIST_LOADING_STATE, false)
        })
    }),

  [ORGSI_SI_ADD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_SI_ADD', topic: 'Добавление СИ', error: null })
      axios({ url: '/api/org/si/addOrgSI.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORGSI_SI_ADD, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'ORGSI_SI_ADD' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORGSI_SI_ADD', result: 'Добавление СИ: ошибка ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_SI_ADD', result: 'Добавление СИ: ошибка сервера' })
          reject(new Error(err))
        })
    }),
  [ORGSI_FILE_ADD]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_FILE_ADD', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/si/uploadOrgSIDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'ORGSI_FILE_ADD' })
            commit(ORGSI_FILE_ADD, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORGSI_FILE_ADD', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_FILE_ADD', result: err })
          reject(new Error(err))
        })
    }),
  [ORGSI_SI_UPDATE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_SI_UPDATE', topic: 'Редактирование СИ', error: null })
      axios({ url: '/api/org/si/updOrgSI.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORGSI_SI_UPDATE, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'ORGSI_SI_UPDATE' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'ORGSI_SI_UPDATE', result: 'Редактирование СИ: ошибка сервера' })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_SI_UPDATE', result: 'Редактирование СИ: ошибка сервера' })
          reject(new Error(err))
        })
    }),

  [ORGSI_SI_DELETE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'ORGSI_SI_DELETE', topic: 'Удаление СИ', error: null })
      axios({ url: '/api/org/si/delOrgSI.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(ORGSI_SI_DELETE, params)
            dispatch(UI_SUCCESS, { action: 'ORGSI_SI_DELETE' })
            resolve(params)
          } else {
            dispatch(UI_ERROR, { action: 'ORGSI_SI_DELETE', result: 'Удаление СИ' + resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'ORGSI_SI_DELETE', result: 'Удаление СИ: ошибка сервера' })
          reject(new Error(err))
        })
    })
}

const mutations = {

  [ORGSI_FREE_DATA]: state => {
    state.currentSI = {}
    state.SIList = []
    state.SIListFilter = null
    state.SIListLoading = false
  },
  [ORGSI_LIST_REQUEST]: (state, resp) => {
    console.log('ORGSI_LIST_REQUEST mutation initiated, ', resp)
    state.SIList = resp
  },
  [ORGSI_SI_ADD]: (state, SIItem) => {
    console.log('ORGSI_SI_ADD mutation initiated', SIItem)
    // Если да, то добавляем новый запрос в гобальный список запросов
    state.SIList.push(SIItem)
  },
  [ORGSI_FILE_ADD]: (state, responce) => {
    console.log('ORGSI_FILE_ADD mutation called, payload ', responce)
    state.currentSI.FILE_LIST.splice(0, state.currentSI.FILE_LIST.length)
    state.currentSI.FILE_LIST.push.apply(state.currentSI.FILE_LIST, responce)
  },
  [ORGSI_SI_UPDATE]: (state, SIItem) => {
    console.log('ORGSI_SI_UPDATE mutation initiated', SIItem)
    const currSI = state.SIList.findIndex(item => item.SI_ID === SIItem.SI_ID)
    if (currSI !== -1) {
      state.SIList.splice(currSI, 1, SIItem)
    } else {
      state.SIList.push(SIItem)
    }
    if (state.currentSI) {
      if (state.currentSI.SI_ID === SIItem.SI_ID) {
        console.log('Updating current SI', SIItem)
        state.currentSI = SIItem
      }
    }
  },
  [ORGSI_SI_DELETE]: (state, SIID) => {
    console.log('ORGSI_SI_DELETE mutation initiated', SIID)
    const currSI = state.SIList.findIndex(item => item.SI_ID === SIID)
    if (currSI !== -1) {
      if (state.currentSI.SI_ID === SIID) {
        state.currentSI = {}
      }
      state.SIList.splice(currSI, 1)
    }
  },
  [ORGSI_FILE_DELETE]: (state, responce) => {
    console.log('ORGSI_FILE_DELETE mutation called, payload ', responce)
    state.currentSI.FILE_LIST.splice(0, state.currentSI.FILE_LIST.length)
    state.currentSI.FILE_LIST.push.apply(state.currentSI.FILE_LIST, responce)
  },
  [ORGSI_GR_REQUEST]: () => {
    console.log('ORGSI_GR_REQUEST mutation initiated, ')
  },

  [ORGSI_SET_SILIST_LOADING_STATE]: (state, resp) => {
    console.log('ORGSI_SET_SILIST_LOADING_STATE mutation initiated, ')
    state.SIListLoading = resp
  },

  [ORGSI_SI_SET]: (state, resp) => {
    console.log('ORGSI_SI_SET mutation initiated, ')
    state.currentSI = resp
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
